<div class="exception-dialog">
  
  <div class="dialog-header">
    <h2 mat-dialog-title>
      <mat-icon>{{ data.exception ? 'edit' : 'add' }}</mat-icon>
      {{ data.exception ? 'Editar excepción' : 'Añadir excepción' }}
    </h2>
    <button mat-icon-button mat-dialog-close class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <form [formGroup]="exceptionForm" class="exception-form">

      <div class="row mb-3">
        <div class="col-md-12">
          <div class="info-box">
            <mat-icon>person</mat-icon>
            <span>{{ data.staffName }}</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Fecha</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="date" required>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="exceptionForm.get('date').hasError('required')">
              La fecha es obligatoria
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <mat-checkbox formControlName="isClosed" class="closed-checkbox">
            Cerrado todo el día
          </mat-checkbox>
        </div>
      </div>

      <div *ngIf="!exceptionForm.get('isClosed').value" class="row">
        <div class="col-md-12">
          <h6 class="section-subtitle">Horario especial</h6>
        </div>

        <div class="col-md-6">
          <app-field [control]="exceptionForm.get('startTime')" [config]="{ 
            label: 'Hora inicio', 
            type: 'time',
            required: true
          }">
          </app-field>
        </div>

        <div class="col-md-6">
          <app-field [control]="exceptionForm.get('endTime')" [config]="{ 
            label: 'Hora fin', 
            type: 'time',
            required: true
          }">
          </app-field>
        </div>
      </div>

      <div *ngIf="exceptionForm.get('isClosed').value" class="closed-info">
        <mat-icon>info</mat-icon>
        <span>Este día estará completamente cerrado para reservas</span>
      </div>

    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <app-button
      label="Cancelar"
      icon="close"
      variant="secondary"
      mat-dialog-close>
    </app-button>
    <app-button 
      [label]="data.exception ? 'Guardar cambios' : 'Añadir excepción'"
      icon="save" 
      variant="primary" 
      [disabled]="exceptionForm.invalid"
      (click)="onSave()">
    </app-button>
  </mat-dialog-actions>

</div>
